// Export plugin object
const ClickOutside =  {
    install:function (Vue){
        Vue.directive('click-outside', {
            bind (el, binding) {
                el.clickOutsideEvent = function(event) {
                    if (!(el == event.target || el.contains(event.target))) {
                        let value = binding.value;
                        if(typeof value === 'function') value(event);
                    }
                };
                document.body.addEventListener('click', el.clickOutsideEvent);
            },
            unbind: function(el) {
                document.body.removeEventListener('click', el.clickOutsideEvent);
            }
        })
    }
}


export default ClickOutside;
